import React, { useContext, useEffect } from "react";
import ReactPaginate from "react-paginate";
import ProductContext from "../../memory/CategoryContext";
import PaginationInput from "./PaginationInput";
import { useSelector } from "react-redux";
import "../../styles/paginationStyling.scss";

const PaginationDataProvider: React.FC<any> = (props: any) => {
  const { totalCount } = useSelector((state: any) => state.rootReducer.category) || 0;

  const productContext = useContext(ProductContext);
  useEffect(() => {
    productContext?.setPagesState({
      totalItems: totalCount,
    });
  }, [totalCount]);

  const handlePageChange = ({ selected }: any) => {
    productContext?.setPages({
      startPage: selected + 1,
    });
  };

  return (
    <>
      <ProductContext.Consumer>
        {(context) => (
          <>
           
            {/* <div className="flex flex-row lg:flex-nowrap justify-end flex-wrap items-center py-4 gap-4">
              <div className="">
                <p className="text-[#9D9595] font-normal text-sm">
                  Showing{" "}
                  <span className="font-semibold">
                    {context?.pages?.startPage}-{context?.pages?.itemsperpage >=
                    context?.pages?.totalItems
                      ? context?.pages?.totalItems -
                        context?.pages?.startPage *
                          context?.pages?.itemsperpage +
                        context?.pages?.itemsperpage * context?.pages?.startPage
                      : context?.pages?.itemsperpage}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold">
                    {context?.pages?.totalItems}
                  </span>{" "}
                  entires
                </p>
              </div>
              <div className="">
                <div className="flex justify-start pagination_custom">
                  <ReactPaginate
                    pageCount={Math.ceil(
                      context?.pages?.totalItems / context?.pages?.itemsperpage
                    )}
                    onPageChange={handlePageChange}
                    forcePage={context?.pages?.startPage - 1} // force the selected page
                    pageRangeDisplayed={5}
                    marginPagesDisplayed={2}
                    previousLabel="<"
                    nextLabel=">"
                    containerClassName="pagination md:flex-nowrap flex-wrap"
                    nextClassName={
                      context?.pages?.startPage ===
                      Math.ceil(
                        context?.pages?.totalItems /
                          context?.pages?.itemsperpage
                      )
                        ? "disabled"
                        : ""
                    }
                    activeClassName="active"
                  />
                </div>
              </div>

        
            </div> */}
          </>
        )}
      </ProductContext.Consumer>
    </>
  );
};

export default PaginationDataProvider;
